import { isClientSide } from 'utility/functions';
import { useEffect, useLayoutEffect } from 'react';
const isSSR = isClientSide() ? false : true;
export const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;
